import { Chip, Box, IconButton, Divider } from "@mui/material";
import { ItemType } from "./utils/constants";
import { Edit, Delete } from "@mui/icons-material";
import { PROCEDURE_TYPE_DISPLAY } from "../procedureTypeDisplay";
import { chapterChipFor } from "../chapterDisplay";
import { NEUTRAL_CHIP_BG } from "../../../../utils/colors";

const UpdateTemplate = ({ template, setTemplateToUpdate }) => (
  <IconButtonWithConfirmation
    icon={<Edit fontSize="small" />}
    onClick={(event) => {
      event.stopPropagation();
      setTemplateToUpdate(template);
    }}
    template={template}
    size="small"
  />
);

const IconButtonWithConfirmation = ({ icon, template, onClick, ...props }) => {
  if (!template.id || !template.actions?.edit) return null;
  return (
    <IconButton {...props} onClick={onClick}>
      {icon}
    </IconButton>
  );
};

const DeleteTemplate = ({ template, setTemplateToDelete }) => (
  <IconButtonWithConfirmation
    icon={<Delete fontSize="small" />}
    onClick={(event) => {
      event.stopPropagation();
      setTemplateToDelete(template);
    }}
    template={template}
    size="small"
  />
);

const ProcedureTypeChip = ({ isPractices, procedureType }) => {
  const config = PROCEDURE_TYPE_DISPLAY[procedureType];
  if (!isPractices || !config) return null;
  return <Chip label={config.label} size="small" sx={config.sx} />;
};

const ChapterChip = ({ isPractices, option }) => {
  const chip = chapterChipFor(option);
  if (!isPractices || !chip) return null;
  return <Chip label={chip.label} size="small" sx={chip.sx} />;
};

const MappedToCurrentHCChip = ({ mappedToCurrentHC, alias }) => {
  if (!mappedToCurrentHC || !alias) return null;
  return <Chip label={`Se hace en ${alias}`} size="small" sx={{ bgcolor: NEUTRAL_CHIP_BG }} />;
};

const SearchOption = ({
  option,
  setTemplateToDelete,
  setTemplateToUpdate,
  isPractices,
  currentHealthCenterAlias,
}) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: 1,
      width: "100%",
    }}
  >
    <Box component="span" sx={{ flex: "1 1 0", minWidth: "min-content" }}>
      {option.name}
    </Box>
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        justifyContent: "flex-end",
        flex: "0 1 auto",
        minWidth: 0,
      }}
    >
      {option.itemType === ItemType.NOMENCLATURE && (
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", lg: "row" },
            alignItems: { xs: "flex-end", lg: "center" },
            gap: { xs: 0.5, lg: 1 },
            minWidth: 0,
            maxWidth: "100%",
          }}
        >
          <ChapterChip isPractices={isPractices} option={option} />
          <MappedToCurrentHCChip
            mappedToCurrentHC={option.mappedToCurrentHC}
            alias={currentHealthCenterAlias}
          />
        </Box>
      )}
      {option.itemType === ItemType.TEMPLATE && option.metadata?.template && (
        <>
          <ProcedureTypeChip isPractices={isPractices} procedureType={option.procedureType} />
          <Chip label={"Plantilla"} size="small" color={"primary"} />
          <Divider orientation="vertical" flexItem />
          <UpdateTemplate
            template={option.metadata.template}
            setTemplateToUpdate={setTemplateToUpdate}
          />
          <DeleteTemplate
            template={option.metadata.template}
            setTemplateToDelete={setTemplateToDelete}
          />
        </>
      )}
    </Box>
  </Box>
);

export default SearchOption;
